function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#666",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M18.819 5.26c-2.15-2.345-5.386-2.627-7.786-.762-1.256.989-2.066 2.26-2.317 3.843-.335 2.092.419 3.816 1.87 5.285-.084.028-.112.057-.167.057-2.54 1.158-4.438 2.995-5.582 5.567-.307.707-.586 1.441-.67 2.204-.223 2.092 1.312 3.703 3.377 3.703h9.823a.312.312 0 00.307-.311v-.933c0-.17-.14-.31-.307-.31H7.35c-1.089 0-1.926-1.046-1.647-2.12.503-2.007 1.507-3.703 3.098-5.003.92-.763 1.981-1.3 3.153-1.639.14-.028.28-.084.42-.028 1.394.565 2.818.594 4.213.028.112-.028.28-.056.39-.028a8.268 8.268 0 013.991 2.43c.335.368.67.792.977 1.187.112.142.28.17.419.057l.753-.509a.336.336 0 00.084-.48c-.39-.48-.753-.961-1.144-1.385-1.005-1.102-2.205-1.893-3.6-2.487 2.679-2.628 2.428-6.133.363-8.365zm-8.652 3.986c0-2.516 1.87-4.409 4.326-4.38 2.512 0 4.354 1.893 4.354 4.408 0 2.515-1.842 4.38-4.354 4.352-2.484 0-4.326-1.865-4.326-4.38z"
}), React.createElement("path", {
  d: "M22.474 23.291h-2.902c-.558 0-.893.311-.893.792 0 .48.335.79.921.79h2.902l.056 3.364c.112.367.502.565.865.48.363-.056.614-.395.642-.82v-3.051h2.986c.475 0 .837-.34.837-.792s-.362-.791-.837-.791h-2.986v-2.967c0-.226-.112-.509-.251-.679-.195-.254-.502-.282-.81-.17-.334.142-.474.396-.474.736l-.056 3.108z"
}));

var SvgIcNavAddEmployee = function SvgIcNavAddEmployee(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "2121769ac1fb503f5904cfa79d4b1cfc.svg";
export { SvgIcNavAddEmployee as ReactComponent };